export enum SLIDER_SETTINGS {
    SPEED_MILLISECONDS = 250,
    THUMB_DEFAULT_LENGTH = 3
}

export const SLIDER_FULL_SETTINGS = Object.freeze({
    dots: false,
    arrows: true,
    infinite: true,
    speed: SLIDER_SETTINGS.SPEED_MILLISECONDS,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    accessibility: false
});

export const SLIDER_THUMB_SETTINGS = Object.freeze({
    arrows: true,
    dots: false,
    focusOnSelect: true,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: SLIDER_SETTINGS.THUMB_DEFAULT_LENGTH,
    speed: SLIDER_SETTINGS.SPEED_MILLISECONDS,
    vertical: true,
    accessibility: false
});
